import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn, Router } from '@angular/router';
import { RepackingStateService } from '../services/repacking-state.service';
import { RepackAddToExistingComponent } from '../components/repack-add-to-existing/repack-add-to-existing.component';

// Guard to prevent navigation to other routes when there's a pending rebind
export const pendingRebindGuard: CanActivateFn = (route, state) => {
  const repackingStateService = inject(RepackingStateService);
  const router = inject(Router);
  
  // Allow navigation to repack-add-to-existing even if there's a pending rebind
  if (state.url.includes('repack-add-to-existing')) {
    return true;
  }
  
  // Check if there's a pending rebind
  if (repackingStateService.hasPendingRebind()) {
    // Redirect to the repack-add-to-existing page
    router.navigate(['/dashboard/repack-add-to-existing']);
    return false;
  }
  
  // No pending rebind, allow navigation
  return true;
};

// Guard to prevent leaving the repack-add-to-existing page when there's a pending rebind
export const canDeactivateRepackAddToExisting: CanDeactivateFn<RepackAddToExistingComponent> = 
  (component, currentRoute, currentState, nextState) => {
    const repackingStateService = inject(RepackingStateService);
    
    // Allow navigation if there's no pending rebind
    if (!repackingStateService.hasPendingRebind()) {
      return true;
    }
    
    // Allow navigation to specific routes even with pending rebind
    if (nextState.url.includes('login')) {
      return true;
    }
    
    // Show confirmation dialog
    return window.confirm(
      'You have unbound parcels that need to be added to a carton. ' +
      'Navigating away now will leave these parcels unassigned. ' +
      'Are you sure you want to continue?'
    );
  };
